import * as React from "react";

function SvgExport(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M0 0h24.727v9.273h-3.09V3.09H3.09v27.818h18.545v-6.182h3.091V34H0V0z"
        fill="#fff"
      />
      <path
        d="M18.546 6.182H6.181v3.09h12.364v-3.09zM18.546 12.364H6.181v3.09h12.364v-3.09zM18.546 18.546H6.181v3.09h12.364v-3.09zM12.364 24.727H6.182v3.091h6.182v-3.09zM29.364 21.636v-3.09h-7.728v-3.091h7.728v-3.091L34 17l-4.636 4.636z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgExport;
